module.exports = __webpack_public_path__ + "static/media/IMG_3481_sm.094c267c.jpg";